import { CustomMedia } from '@gsc/types'
import { useAppSelector } from '../store/store'
import { selectWidgetById } from '../store/widgets'
import { useWidgetContext } from './useWidgetContext'

const DEFAULT_CUSTOM_MEDIA: CustomMedia = {
  '--mobile': '(max-width: 960px)',
  '--desktop': '(min-width: 960.02px)',
}

export function useCustomMedia(): CustomMedia {
  const { widgetId } = useWidgetContext()
  return useAppSelector(s => selectWidgetById(s, widgetId).data?.customMedia) || DEFAULT_CUSTOM_MEDIA
}
